exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.payee {\n  display: block;\n  width: 100%;\n  height: 31px;\n  padding: 6px 12px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #555;\n  background: #eee none;\n  border: none;\n  border-radius: 3px;\n}\nspan.payee:hover {\n  background: #d6d6d8;\n}\na.payeeSwitch {\n  background: #fff none;\n}\n", ""]);

// exports
